import {XauditModel} from '../../xaudit.model';

export class NotificationNeededItemDataModel extends XauditModel {
  dataNotificationNeededItemID: string;
  NotificationNeededID: string;
  enumNeededItemTypeID: string = '00000228-1000-0000-0000-000000000001'; // Currently we only have 1 type (Letter)
  enumLetterDeliveryToRoleID: string;
  enumLetterDeliveryEmailTypeID: string;
  ObjectID: string;
  Description: string;
  ToContactID: string;
  enumLetterDeliveryMethodID: string = '00000251-1000-0000-0000-000000000001'; // Currently we are only handling Email
  DeliveredOn: Date;
  DeliveredBy: string;
  Subject: string;
  // Send-time "Letters Email From:" override: the source location whose EmailReturnAddress
  // should be used as the From address. Empty means no override (backend applies the
  // location -> client -> default fallback chain). See TX-7010.
  EmailFromLocationID: string = '';

  // Front end use only
  contactType: string = '';
}
